import { INavLink } from "core-integration/src/hooks/types";
import React from "react";
import { NavLink } from "react-router";
import styled from "styled-components";

const LIStyled = styled.li`
  list-style-type: none;
`;

const ListItem: React.FC<INavLink> = ({
  useRouter,
  text,
  href,
  rel,
  target,
}) => {
  return (
    <LIStyled>
      {useRouter ? (
        <NavLink
          to={href}
          className={({ isActive }) =>
            isActive ? `ism-nav__tab active` : `ism-nav__tab`
          }
        >
          {text}
        </NavLink>
      ) : (
        <a href={href} className="ism-nav__tab" rel={rel} target={target}>
          <span>{text}</span>
        </a>
      )}
    </LIStyled>
  );
};

export default ListItem;
